export default __webpack_public_path__ + "static/featured-7e9acda835f2e2ecfe0c6ee1426c9e28.svg";